import { useQuery, UseQueryResult } from "@tanstack/react-query";

import * as config from "@/config";

import { hermesFetch, HermesApiError } from "./hermes-fetch";
import { useHermesApiToken } from "./use-hermes-api-token";

export interface IssueSummary {
  group_id: string;
  students: {
    user_id: string;
    completed: number;
    on_track: number;
    overdue: number;
    total: number;
  }[];
}

/**
 * Hook to fetch the Issue Summary Insights data from Hermes.
 */
export function useIssueSummaryInsights(
  assessmentId: string,
  workId: string,
  studentIds: string[]
): UseQueryResult<IssueSummary[]> {
  const apiToken = useHermesApiToken({ assessmentId, workId });
  return useQuery(
    [`insights/issues`, studentIds],
    async () => {
      const hermesUrl = `${config.HERMESV2_ENDPOINT}/api/insights/issues`;

      return hermesFetch<IssueSummary[]>(hermesUrl, apiToken, {
        method: "POST",
        body: JSON.stringify({
          user_ids: studentIds,
          group_ids: [],
        }),
      });
    },
    {
      cacheTime: 100,
      refetchInterval: false,
      useErrorBoundary: (error) =>
        error instanceof HermesApiError && error.status === 401,
      enabled: !!apiToken,
    }
  );
}
